import { useState,useEffect } from 'react';
import RemittanceViewId from './RemittanceViewId';
import {AGENT_LEAD_TYPES} from '../../config/constant'
import { useParams } from 'react-router-dom';

const SECTION_IDS = ['partner', 'agency-commission', 'agency-points'];

const RemittanceDetailTabsId = (props: any) => {
    const { remittanceDetails,callReloadApi,setCallReloadApi,revenue,remittance_status,paymentMadeFrom,ribbonData } = props;
    const { type } = useParams<{ type: string }>();
    const [selectedTab, setSelectedTab] = useState<string>("partner");
    // const [callReloadApi , setCallReloadApi] = useState(0);
    const [isPartnerRemittanceExists , setIsPartnerRemittanceExists] = useState(false);
    const [isReferralRemittanceExists , setIsReferralRemittanceExists] = useState(false);
    const [isAgencyRemittanceExists , setIsAgencyRemittanceExists] = useState(false);

    const isLeadFromAgency = AGENT_LEAD_TYPES.includes(revenue?.application_type_id);

    const scrollToSection = (sectionId: string, behavior: ScrollBehavior = 'smooth') => {
        const targetSection = document.getElementById(sectionId);
        if (!targetSection) return;

        targetSection.scrollIntoView({ behavior, block: 'start' });
        setSelectedTab(sectionId);
    };

    useEffect(() => {
        const container = document.querySelector('.remittance-wrapper');
        if (!container) return;

        const handleScroll = () => {
            for (let i = SECTION_IDS.length - 1; i >= 0; i--) {
            const el = document.getElementById(SECTION_IDS[i]);
            if (el) {
                const top = el.getBoundingClientRect().top - container.getBoundingClientRect().top;
                if (top <= 150) {
                setSelectedTab(SECTION_IDS[i]);
                break;
                }
            }
            }
        };

        container.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => container.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const targetSection = SECTION_IDS.includes(type || '') ? type! : 'partner';

        setSelectedTab(targetSection);

        const timeoutId = window.setTimeout(() => {
            scrollToSection(targetSection, 'auto');
        }, 100);

        return () => window.clearTimeout(timeoutId);
    }, [type, remittanceDetails]);


    return (
        <div className="lead-detail-tabs">
        <div className="detail-form-sec">
            <div className="menu-tab-left-panel remitttance-side-bar">
                <div className="dealer-tab-left-panel nav">
                <ul>
                    <li >
                        <a href=":" className={selectedTab === 'partner' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('partner');}}>Insurance Partner Payment</a>
                    </li>
                    <li >
                        <a href=":" className={selectedTab === 'agency-commission' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('agency-commission');}}>Agency - Commission</a>
                    </li>
                    <li >
                        <a href=":" className={selectedTab === 'agency-points' ? 'active' : ''} onClick={(e) => { e.preventDefault(); scrollToSection('agency-points');}}>Agency - Points</a>
                    </li>
                </ul>
                </div>
            </div>
            <div className="route-files">
                <RemittanceViewId isLeadFromAgency={isLeadFromAgency} remittanceDetails={remittanceDetails} revenue={revenue} callReloadApi={callReloadApi} setCallReloadApi={setCallReloadApi} remittance_status={remittance_status}
                paymentMadeFrom={paymentMadeFrom} ribbonData={ribbonData}></RemittanceViewId>
            </div>
        </div>
        </div>
    );
}

export default RemittanceDetailTabsId;